import { DateFormatType, DateSelectionType } from 'beesoft-components';
import type { Control, FieldValues } from 'react-hook-form';
import type { DynamicFieldComponentProps } from '../../dynamic-form/dynamic-form.interfaces';
import OdinController from '../../dynamic-form/odin-controller.component';
import type { CurrentTimeButton } from './date-time.component';
import OdinDateTime from './date-time.component';

export interface HfTimeFieldProps extends DynamicFieldComponentProps<string | Date | Date[]> {
  control: Control<FieldValues>;
  name: string;
  currentTimeBtn?: CurrentTimeButton;
}

export default function HfTimeField({
  control,
  name,
  label,
  readOnly,
  required,
  currentTimeBtn,
  onChange,
  fieldValueConverter,
  labelStyles,
}: HfTimeFieldProps) {
  return (
    <OdinController
      name={name}
      control={control}
      onChange={onChange}
      fieldValueConverter={fieldValueConverter}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        const [hour, minute] = value
          ? String(value)
              .split(':')
              .map((item) => Number(item))
          : [undefined, undefined];
        const currentDate = new Date(Date.now());
        const dateValue =
          hour !== undefined && minute !== undefined
            ? new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), hour, minute)
            : undefined;

        return (
          <OdinDateTime
            label={label}
            value={dateValue}
            error={error?.message}
            onChange={(newValue) => {
              if (newValue && typeof newValue !== 'string' && !Array.isArray(newValue)) {
                const temp =
                  String(newValue.getHours()).padStart(2, '0') + ':' + String(newValue.getMinutes()).padStart(2, '0');
                onChange(temp);
              } else {
                onChange(newValue);
              }
            }}
            currentTimeBtn={currentTimeBtn}
            dateSelectionType={DateSelectionType.TimeOnly}
            dateFormatType={DateFormatType.Short}
            readOnly={readOnly}
            required={required}
            labelStyles={labelStyles}
          />
        );
      }}
    />
  );
}
